import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '@fortawesome/fontawesome-free/css/all.css';

ReactDOM.render(<App />, document.getElementById('root'));
